// extracted by mini-css-extract-plugin
module.exports = {"header":"SubCategoryHeader_header__g5h9m"};